import { Box, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

const StandaloneBadgeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  minWidth: '1.5rem',
  height: '1.25rem',
  padding: `0 ${theme.spacing(1)}`,
  backgroundColor: theme.palette.custom.OV.sys.surfaceVariant,
  color: theme.palette.custom.OV.sys.onSurface,
  borderRadius: '6.25rem',
}));

export const StandaloneBadge = ({ badgeContent }: { badgeContent: ReactNode }) => {
  return (
    <StandaloneBadgeContainer>
      <Typography variant="body1" fontSize="small" component="span">
        {badgeContent}
      </Typography>
    </StandaloneBadgeContainer>
  );
};
